import { lazy, Suspense } from "react";

import { SilentBoundary } from "@/components/follows/StorefrontFollowSlot";
import type { StorefrontWantMatchProps } from "@/components/wants/StorefrontWantMatchGate";
import { useClerkSessionHint } from "@/lib/platform/clerkSessionHint";

// Lazy for the reason the Follow slot is: a public route's entry chunk must import no Clerk.
const StorefrontWantMatchGate = lazy(() => import("@/components/wants/StorefrontWantMatchGate"));

/**
 * Where a shop's page shows the caller's Want matches, and the only thing the page imports to do it.
 *
 * Holds no Clerk import. On web it renders nothing while the session hint says signed out, so
 * those visitors never download the control. A chunk that fails to load, or a control that throws,
 * leaves the page as it was and reports no matched units.
 */
export function StorefrontWantMatchSlot(props: StorefrontWantMatchProps) {
  if (!useClerkSessionHint()) return null;
  return (
    <SilentBoundary>
      <Suspense fallback={null}>
        <StorefrontWantMatchGate {...props} />
      </Suspense>
    </SilentBoundary>
  );
}
